module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/orchestra-6663177a9547e4358531ed6ac2973f94.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/orchestra.svg
// module id = PjWn
// module chunks = 24